module.exports = __webpack_public_path__ + "static/media/fail.c8fbfa71.svg";